const getValueByFieldName = (values, name) => {
  const keyToFind = Object.keys(values)
    .find(key => key === name);

  const toReturn = values[keyToFind];

  // Used to keep suggest working
  if (toReturn && typeof toReturn === 'object' && toReturn.value) {
    return toReturn.value;
  }

  return toReturn;
};



export default getValueByFieldName;
